module.exports = __webpack_public_path__ + "8569855fb75b119cd149bf04f67e0070.svg";